import { createSelector, createSlice } from '@reduxjs/toolkit';

const calendarShiftsSlice = createSlice({
    name: 'calendarShifts',
    initialState: {
        shifts: [],
        isLoading: false,
        rangeStart: null,
        rangeEnd: null,
        filterMode: 'none',
        contractor: null,
        client: null,
    },
    reducers: {
        fetchCalendarShifts: (state, { payload }) => {
            state.isLoading = true;
            state.rangeStart = payload.rangeStart;
            state.rangeEnd = payload.rangeEnd;
        },
        calendarShiftsFetched: (state, { payload }) => {
            state.shifts = payload.shifts;
            state.isLoading = false;
        },
        calendarShiftsFetchFailed: state => {
            state.isLoading = false;
            state.shifts = [];
        },
        setContractorFilter: (state, { payload }) => {
            state.contractor = payload;
            state.filterMode = payload ? 'contractor' : 'none';
            state.client = null;
        },
        setClientFilter: (state, { payload }) => {
            state.client = payload;
            state.filterMode = payload ? 'client' : 'none';
            state.contractor = null;
        },
        clearCalendarFilters: state => {
            state.contractor = null;
            state.client = null;
            state.filterMode = 'none';
        },
    },
});

export const {
    fetchCalendarShifts,
    calendarShiftsFetched,
    calendarShiftsFetchFailed,
    setContractorFilter,
    setClientFilter,
    clearCalendarFilters,
} = calendarShiftsSlice.actions;

const selectSlice = state => state.calendarShifts;

export const getCalendarShifts = createSelector(selectSlice, s => s.shifts);
export const isCalendarLoading = createSelector(selectSlice, s => s.isLoading);
export const getCalendarFilterMode = createSelector(
    selectSlice,
    s => s.filterMode,
);
export const getCalendarContractor = createSelector(
    selectSlice,
    s => s.contractor,
);
export const getCalendarClient = createSelector(selectSlice, s => s.client);

export default calendarShiftsSlice.reducer;
